<template>
  <b-container>
    <b-row>
      <h1>Editar conexão</h1>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </b-row>
    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <crud-data-create :model="model" :modelstate="modelstate" class="mb-4">
    </crud-data-create>
    <b-button class="button" @click="save" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
  </b-container>
</template>

<script>
import CrudDataCreate from "@/components_rms/System/SystemIntegration/CrudDataCreate.vue";
export default {
  components: {
    CrudDataCreate,
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  props: {
    id: String,
    empresaId: String,
    itegrationCompanyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        apiUserName: "",
        apiGuid: "",
        apiPassword: "",
        apiUrlBase: "",
        dbServerName: "",
        dbPort: "",
        dbUserName: "",
        dbPassword: "",
        dbSchema: "",
      },
    };
  },
  computed: {
    getUrlBackToList() {
      return `../../../list/${this.empresaId}/${this.itegrationCompanyId}`;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      console.log(this.id)
      this.$apiChecklist
        .get("/systemIntegrationCompany/loadConnection/" + this.id)
        .then((response) => {
          this.model = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
                this.alert.error = "Load data error";
              } else {
                if (error.response.data) {
                  this.alert.error = error.response.data.errors;
                } else {
                  this.alert.error = `${error.response.status} - ${error.response.statusText} `;
                }
              }
            } else {
              this.alert.error = error.message;
            }
            this.$refs.fadeAlertDanger.show();
            window.scrollTo(0, 0);
          }
        });
    },
    save() {
      this.submitted = true;
      this.$apiChecklist
        .post("/systemIntegrationCompany/editConnection/" + this.id, this.model)
        .then((response) => {
          if (response.data.success) {
            this.$refs.alert.show();
          } else {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          }
          this.modelstate = {};
          window.scrollTo(0, 0);
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
            } else {
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
          window.scrollTo(0, 0);
        });
    },
  },
};
</script>
